import { logUsage } from 'owa-analytics';
import getAssets from '../selectors/getAssets';
import { DatapointVariant } from 'owa-analytics-types';
import type { ProjectId } from 'owa-timestream-types';

export default function logAssetsLoaded(projectId: ProjectId) {
    const assetTypes = getAssets(projectId).map(([id, asset]) => asset.type);
    const assetList = assetTypes.reduce((a, type) => {
        a[type] = (a[type] || 0) + 1;
        return a;
    }, {});
    logUsage(
        'OUTLOOKSPACES_ASSETS_LOADED',
        {
            ...assetList,
            assetCount_1: assetTypes.length,
        },
        {
            variant: DatapointVariant.WarmOnly,
        }
    );
}
